// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import ReactGA from "react-ga4";
import Loader from '../../../../components/Utils/Loader'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postShareInstallation = endpointHelias+"/Helias/V0/Configuration/postShareInstallation"

var initialConfigCommonJS = require("../../../../js/initialConfigCommon.js");
var generalCommonJS = require("../../../../js/generalCommon.js")

// Initial config - Meteo
const ShareWithUser = (params) => {

  useEffect(() => {      
    console.log("Página para compartir con usuario cargada correctamente.")
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {      
      compartirInstalacionConUsuario()
    }
  } 

  function compartirInstalacionConUsuario(){

    document.getElementById("emailUsuarioConQuienCompartir").className = ""

    var emailUsuarioConQuienCompartir = document.getElementById("emailUsuarioConQuienCompartir").value.toLowerCase()

    if(!localStorage.getItem("currentSharingStatus").includes(emailUsuarioConQuienCompartir)){

      if ( (document.getElementById("emailUsuarioConQuienCompartir").value.includes("@")) && (document.getElementById("emailUsuarioConQuienCompartir").value.includes(".")) ) {
        
        if(emailUsuarioConQuienCompartir !== generalCommonJS.obtenerEmailUsuario()){
        
          var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
          var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    

          document.getElementById("loaderShareInstallation").className = "loader overlay"
          
          //Petición de datos para el paso actual
          var jsonPeticion = {
            "accountID": localStorage.getItem("accountID"),
            "installationID": localStorage.getItem("installationId"),        
            "userEmail": emailUsuarioConQuienCompartir
          }
        
          // Guardo la información  
          var xhttp = new XMLHttpRequest();  
            xhttp.open("POST", postShareInstallation, true);        
            xhttp.setRequestHeader('Content-Type', "application/json");
            xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
            var data = JSON.stringify(jsonPeticion);
            xhttp.onreadystatechange = function() {
              if (this.readyState === 4 && this.status === 200) {
                var jsonRespuesta = JSON.parse(this.responseText)
        
                if(jsonRespuesta.statusCode === "403"){                   
                  initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
                }
                if(jsonRespuesta.statusCode === "204"){                   
                  initialConfigCommonJS.mostrarMensajeInformativo("Instalación compartida correctamente. "+emailUsuarioConQuienCompartir+" actualmente no tiene cuenta en HELIAS, pero le hemos enviado un email de invitación.","positive")
                  document.getElementById("emailUsuarioConQuienCompartir").value = ""
                  params.seleccionarOpcionSharing("verEstadoComparticion")
                }
                else{          
                  //Si recibo datos ya configurados lo cargo  

                  document.getElementById("emailUsuarioConQuienCompartir").value = ""                

                  initialConfigCommonJS.mostrarMensajeInformativo("Instalación compartida con "+emailUsuarioConQuienCompartir+" correctamente.","positive")                                

                  params.seleccionarOpcionSharing("verEstadoComparticion")

                  generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'COMPARTIR - Con usuario', "", "")
                  
                  //Si no hay datos configurados entonces no hago nada  
                  console.log("Instalación compartida correctamente.")
                }

                document.getElementById("loaderShareInstallation").className = "loader hidden"

              }
        
              if (this.readyState === 4 && this.status !== 200) {      
                initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)          
              }
            }
            xhttp.send(data);      
        }
        else{
          initialConfigCommonJS.mostrarMensajeInformativo("No puedes compartirte la instalación a ti mismo, ¡es tuya!","negative")
          document.getElementById("emailUsuarioConQuienCompartir").value = ""
        }

      }
      else{
        initialConfigCommonJS.mostrarMensajeInformativo("Debes introducir un e-mail correcto.","negative")
        document.getElementById("emailUsuarioConQuienCompartir").className = "error"
      }
    }
    else{
      initialConfigCommonJS.mostrarMensajeInformativo("A "+emailUsuarioConQuienCompartir+" ya le has compartido esta instalación, prueba con otro.","info")
    }

  }


  return (          
    <div className="content-wrapper"> 

      <div className="message info left">
        <h1>Al compartir esta instalación debes saber que... </h1>
        <ul className="default-list">
          <li className="arrow">Si el usuario (e-mail) con quien vas a compartir la instalación no está registrado en Helias le enviaremos un email de invitación.</li>
          <li className="arrow">El usuario al que le compartas la instalación podrá consultar los datos de esta instalación, crear reglas/alertas e interactuar con tus dispositivos.</li>
        </ul>
      </div>

      <fieldset className="text">        
        <input type="text" id="emailUsuarioConQuienCompartir" placeholder="E-Mail" onKeyDown={handleKeyDown}/>
        <button className="button primary hug" onClick={() => compartirInstalacionConUsuario()}>Compartir instalación</button>
      </fieldset>

      <Loader Id="loaderShareInstallation" Mensaje=""/>

    </div>
  )
}

export default ShareWithUser